import { getJSON } from "../helpers/core";

export const BarsCompatibilitiesForNetwork = (network, bars) =>
  getJSON("MobileProvisioning/BarsCompatibilitiesForNetwork", {
    active: bars,
    network: network,
    by_ids: 1
  });
